// extracted by mini-css-extract-plugin
export default {"graphColor":"#e0ecec","lineColor":"#001e62","fontColor":"#838ca3","fontSize":"14px","graph":"style--graph--e6e352","graphContainer":"style--graphContainer--1796b3"};